<span [class]="'text-xs font-bold rounded-full py-0.5 px-2 whitespace-nowrap ' + badgeClass()">
  {{ 'timesheet.billing-state.' + state() | translate }}
</span>
